import React, { useState } from "react";
import "./PendingRequestsPage.css";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import vi from "date-fns/locale/vi";
import RequestDetailModal from "../../components/RequestDetailModal/RequestDetailModal";
import ConfirmActionModal from "../../components/ConfirmActionModal/ConfirmActionModal";
import { useRolePermission } from "../../hooks/useRolePermission";

registerLocale("vi", vi);

const PendingRequestsPage = () => {
    const [openDetail, setOpenDetail] = useState(false);
    const [openReject, setOpenReject] = useState(false);
    const [selectedReq, setSelectedReq] = useState(null);
    const { permissions } = useRolePermission();
    const [filters, setFilters] = useState({
        loaiYeuCau: "",
        trangThai: "",
        fromDate: "",
        toDate: "",
    });

    const data = [
        {
            time: "2025-03-05 09:00:00",
            user: "lansn",
            chinhanh: "069",
            loaiGD: "Đóng",
            loaiYC: "Đại lý",
            idDLTT: "ID-00001234-068-001",
            cifDLTT: "00007899",
            tenDLTT: "Đại lý Thanh toán Như Ý",
            trangThai: "Chờ duyệt",
            tktt: "4444444444",
        },
        {
            time: "Content",
            user: "Content",
            chinhanh: "Content",
            loaiGD: "Tạm khóa",
            loaiYC: "Nhân viên",
            idDLTT: "Content",
            cifDLTT: "Content",
            tenDLTT: "Content",
            trangThai: "Đã duyệt",
            tktt: "Content",
        },
        {
            time: "Content",
            user: "Content",
            chinhanh: "Content",
            loaiGD: "Tạo mới",
            loaiYC: "Nhân viên",
            idDLTT: "Content",
            cifDLTT: "Content",
            tenDLTT: "Content",
            trangThai: "Đã duyệt",
            tktt: "Content",
        },
        {
            time: "Content",
            user: "Content",
            chinhanh: "Content",
            loaiGD: "Chỉnh sửa",
            loaiYC: "Nhân viên",
            idDLTT: "Content",
            cifDLTT: "Content",
            tenDLTT: "Content",
            trangThai: "Đã duyệt",
            tktt: "Content",
        },
    ];

    const handleChange = (e) =>
        setFilters({ ...filters, [e.target.name]: e.target.value });

    const handleDateChange = (date, name) =>
        setFilters((prev) => ({ ...prev, [name]: date }));

    const handleSearch = () => console.log(filters);
    const handleReset = () =>
        setFilters({ loaiYeuCau: "", trangThai: "", fromDate: "", toDate: "" });
    // Click icon mắt
    const openDetailModal = (row) => {
        setSelectedReq(row);
        setOpenDetail(true);
    };

    // xử lý duyệt
    const handleApprove = () => {
        console.log("DUYỆT:", selectedReq);
        setOpenDetail(false);
    };

    // khi nhấn nút từ chối trong RequestDetailModal
    const handleRejectClick = () => {
        setOpenDetail(false);
        setOpenReject(true);
    };

    // xử lý xác nhận từ chối
    const handleRejectConfirm = (reason) => {
        console.log("BỊ TỪ CHỐI:", selectedReq, "Lý do:", reason);
        setOpenReject(false);
    };
    return (
        <div className="pending-req-container">
            <h2 className="pending-title">Giao dịch chờ duyệt</h2>

            {/* FORM */}
            <div className="pending-filter-card">
                <div className="pending-grid">
                    <div className="pending-item">
                        <label>Loại yêu cầu</label>
                        <select
                            name="loaiYeuCau"
                            value={filters.loaiYeuCau}
                            onChange={handleChange}
                        >
                            <option value="">Chọn loại yêu cầu</option>
                            <option value="dong">Đóng</option>
                            <option value="tamkhoa">Tạm khóa</option>
                            <option value="taomoi">Tạo mới</option>
                        </select>
                    </div>

                    <div className="pending-item">
                        <label>Trạng thái</label>
                        <select
                            name="trangThai"
                            value={filters.trangThai}
                            onChange={handleChange}
                        >
                            <option value="">Tất cả</option>
                            <option value="choduyet">Chờ duyệt</option>
                            <option value="daduyet">Đã duyệt</option>
                            <option value="tuchoi">Từ chối</option>
                        </select>
                    </div>

                    {/* FROM DATE */}
                    <div className="pending-item">
                        <label>Từ ngày (From Date)</label>
                        <div className="pending-date-wrapper">
                            <img
                                src="/icons/icons8-calendar-100.png"
                                className="pending-date-icon"
                            />
                            <DatePicker
                                selected={filters.fromDate}
                                onChange={(d) => handleDateChange(d, "fromDate")}
                                placeholderText="dd/mm/yyyy"
                                dateFormat="dd/MM/yyyy"
                                locale="vi"
                                className="pending-datepicker"
                            />
                        </div>
                    </div>

                    {/* TO DATE */}
                    <div className="pending-item">
                        <label>Đến ngày (To Date)</label>
                        <div className="pending-date-wrapper">
                            <img
                                src="/icons/icons8-calendar-100.png"
                                className="pending-date-icon"
                            />
                            <DatePicker
                                selected={filters.toDate}
                                onChange={(d) => handleDateChange(d, "toDate")}
                                placeholderText="dd/mm/yyyy"
                                dateFormat="dd/MM/yyyy"
                                locale="vi"
                                className="pending-datepicker"
                            />
                        </div>
                    </div>
                </div>

                <div className="pending-actions">
                    <button className="btn-secondary" onClick={handleReset}>
                        Xóa lọc
                    </button>
                    <button className="btn-primary" onClick={handleSearch}>
                        Tìm kiếm
                    </button>
                </div>
            </div>

            {/* HEADER */}
            <div className="pending-result-header">
                <h3 className="pending-result-title">Kết quả tìm kiếm</h3>

                <div className="pending-search-inline">
                    <img src="/icons/icons8-search-100.png" className="pending-search-icon" />
                    <input placeholder="Tìm kiếm nhanh trong bảng..." />
                </div>
            </div>

            {/* TABLE */}
            <div className="pending-table-wrapper">
                <table className="pending-table">
                    <thead>
                        <tr>
                            <th>Thao tác</th>
                            <th>Thời gian tạo</th>
                            <th>User tạo</th>
                            <th>Chi nhánh</th>
                            <th>Loại giao dịch</th>
                            <th>Loại yêu cầu</th>
                            <th>ID ĐLTT/User</th>
                            <th>CIF ĐLTT</th>
                            <th>Tên ĐLTT</th>
                            <th>Trạng thái</th>
                            <th>TKTT giao dịch</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((row, idx) => (
                            <tr key={idx}>
                                <td>
                                    <img
                                        src="/icons/icons8-eye-100.png"
                                        className="eye-icon"
                                        onClick={() => openDetailModal(row)}
                                    />
                                </td>
                                <td>{row.time}</td>
                                <td>{row.user}</td>
                                <td>{row.chinhanh}</td>
                                <td>{row.loaiGD}</td>
                                <td>{row.loaiYC}</td>
                                <td>{row.idDLTT}</td>
                                <td>{row.cifDLTT}</td>
                                <td>{row.tenDLTT}</td>
                                <td>{row.trangThai}</td>
                                <td>{row.tktt}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* PAGINATION */}
            <div className="pagination">
                <span>Số lượng bản ghi: 4/10 (trên 10 bản ghi/trang)</span>
                <div className="pager">
                    <button disabled>Trước</button>
                    <button className="active">1</button>
                    <button>Sau</button>
                </div>
            </div>
            {/* POPUP DETAIL */}
            <RequestDetailModal
                open={openDetail}
                onClose={() => setOpenDetail(false)}
                data={selectedReq}

                // --- THAY ĐỔI Ở ĐÂY ---
                // Thay vì showActions={true}, chỉ hiện nếu có quyền Approve
                showActions={permissions.canApprove}

                onApprove={handleApprove}
                onReject={handleRejectClick}
            />

            {/* POPUP NHẬP LÝ DO TỪ CHỐI */}
            <ConfirmActionModal
                isOpen={openReject}
                onCancel={() => setOpenReject(false)}
                onConfirm={handleRejectConfirm}
            />
        </div>
    );
};

export default PendingRequestsPage;
